"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var continueInDealershipStyles = styles_1.makeStyles(function (theme) { return ({
    paragraph: {
        margin: theme.spacing(2) + " 0 " + theme.spacing(2) + " 0",
    },
}); }, { name: 'Checkout_ConfirmationInDealership' });
exports.default = continueInDealershipStyles;
